import Reveal from "@/components/Reveal";
import DnaHelix from "@/components/DnaHelix";

export default function PageHeader({ eyebrow, title, description }) {
    return (
        <header className="relative pt-40 pb-20 sm:pt-48 sm:pb-24 px-6 lg:px-8 overflow-hidden">
            <DnaHelix className="absolute right-6 lg:right-24 top-24 h-72 w-auto text-brand/10 hidden md:block" />
            <div className="max-w-7xl mx-auto relative">
                <Reveal>
                    <p className="eyebrow mb-6">{eyebrow}</p>
                    <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-brand max-w-3xl">
                        {title}
                    </h1>
                    {description && (
                        <p className="mt-8 text-base sm:text-lg leading-relaxed tracking-wide text-mist max-w-2xl">
                            {description}
                        </p>
                    )}
                    <div className="gold-hairline mt-12 max-w-xs" />
                </Reveal>
            </div>
        </header>
    );
}
